const FORM_FIELDS_TYPE = {
  VEHICLE_HISTORY: 'VEHICLE_HISTORY',
  VEHICLE_FINANCING: 'VEHICLE_FINANCING'
}
export default FORM_FIELDS_TYPE
